import { ActionTypes } from "@/actions";
import { addFileLink } from "@/app/api/file";
import { all, call, takeEvery } from "redux-saga/effects";

const workerNewFileWithRelation = function* (action: any): Generator<any, void, any> {
    try {
        const filename = String(action.payload?.filename || "").trim();
        const relation = action.payload?.relation;
        if (!filename || !relation?.table || !relation?.uid || !relation?.field) {
            return;
        }
        const res = yield call(addFileLink, {
            collection: relation.table,
            itemUid: String(relation.uid),
            field: relation.field,
            filename,
        });
        console.log('workerNewFileWithRelation', res);
    } catch (error: any) {
        console.error('workerNewFileWithRelation', error);
    }
}

const workerFileDelete = function* (action: any): Generator<any, void, any> {
    try {
        console.log('workerFileDelete', action.payload);
    } catch (error: any) {
        console.error('workerFileDelete', error);
    }
}

export function* watcherFileSaga() {
    yield all([
        takeEvery(ActionTypes.FILE_NEW_WITH_RELATION, workerNewFileWithRelation),
        takeEvery(ActionTypes.FILE_DELETE, workerFileDelete),
    ])
}